import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addDietTypesApi, listOfDietTypesApi, updateDietTypesApi } from "../../../../../config/Api";
export const DietTypes = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [isActive, setIsActive] = useState(false)
    const [buttonName, setButtonName] = useState('ADD')
    const [DietTypeData, setDietTypeData] = useState()
    const [editDietTypeRecord, setEditDietTypeRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of all Diet Types
    const getListOfDietTypes = () => {
        setLoading(true)

        listOfDietTypesApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    }

    // call when user click on edit
    const editDietType = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        setEditDietTypeRecord(data);
    }

    useEffect(() => {
        getListOfDietTypes()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterDietType(DietTypeData);
    }, [DietTypeData]);

    // filter Diet Types
    const filterDietType = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };

    // update status of Diet Types
    const onChange = (checked, data) => {
        let updatedData = data;
        updatedData.status = checked;

        updateDietTypesApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Diet Type Update successfully",
                    });
                    getListOfDietTypes()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
    };

    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "status": true
            }
            addDietTypesApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        notification.success({
                            message: "Diet Type added successfully",
                        });
                        getListOfDietTypes()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "status": values.status
            }
            updateDietTypesApi(editDietTypeRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Diet Type Update successfully",
                        });
                        getListOfDietTypes()
                        form.setFieldsValue({ 'name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => <>
                <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} />
            </>,
            filters: [
                { text: "Active", value: true },
                { text: "DeActive", value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editDietType(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="DietType">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addDietTypesForm"
                        // className="addDietTypesForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addDietTypesForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter DietType Name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter DietType Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total : {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search DietType"
                        onChange={(e) => { filterDietType(e.target.value); setDietTypeData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
